
import React, {
  Component,
  PropTypes
} from 'react';

import {
  Image,
  Modal,
  Button,
  Grid, Row, Col,
} from 'react-bootstrap';

class MoreInfo extends Component {
  state = {
    show: false
  }

  updateShow = () => {
    this.setState({ show: true });
  }

  render = () => {
    const stack = this.props.stack;

    let close = () => this.setState({ show: false});

    return (
      <div>
        <Button
          id={stack.name}
          bsStyle="info"
          bsSize="small"
          onClick={this.updateShow}
        >
          More info
        </Button>

        <Modal
          dialogClassName="more_info_modal_container"
          bsSize="lg"
          show={this.state.show}
          onHide={close}
          // container={container}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title>{stack.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* fluid is important here to prevent text overlow - to make
              everything fit inside the modal box. */}
            <Grid fluid>
              <Row>
                <Col md={4}>
                  <Image src={stack.image} rounded />
                </Col>
                <Col md={6} className="text">
                  <stack.moreInfo />
                </Col>
              </Row>
            </Grid>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={close}>Close</Button>
          </Modal.Footer>
        </Modal>
     </div>
    );
  }
}

MoreInfo.propTypes = {
  stack: PropTypes.shape().isRequired
};

export default MoreInfo;



// WEBPACK FOOTER //
// ./src/components/stacks/MoreInfo.js